export const patientHome = [{ title: "Home", link: "/home" }];

export const patientEdit = [{ title: "Home", link: "/patients" }];

export const patientNew = [
  { title: "Home", link: "/patients" },
  { title: "New Patient", link: "/patients/new" },
];


export const visitHome = [
  { title: "Home", link: "/patients" },
  { title: "Patient", link: "/patient/1" },
  { title: "Visit", link: "/visits/1" },
];

export const treatmentHome = [
  { title: "Home", link: "/patients" },
  { title: "Patient", link: "/patient/1" },
  { title: "F/U sputum examination", link: "/treatment/1" },
];

export const postTreatmentHome = [
  { title: "Home", link: "/patients" },
  { title: "Patient", link: "/patient/1" },
  { title: "Post Treatment", link: "/post_treatment/1" },
];

export const treatmentChangesHome = [
  { title: "Home", link: "/patients" },
  { title: "Patient", link: "/patient/1" },
  { title: "Treatment Changes", link: "/treatment_changes/1" },
]